import React, { Fragment } from 'react'
import { Star, StarFill } from 'react-bootstrap-icons'
import Rating from 'react-rating'
import ErrorMessage from './ErrorMessage'
import Label from './Label'

export default function CustomRating({
  initialRating,
  fractions = 4,
  readonly = false,
  emptySymbol = <div className="text-yellow-400"><Star className="w-5 h-5 mr-1" /></div>,
  fullSymbol = <div className="text-yellow-400"><StarFill className="w-5 h-5 mr-1" /></div>,
  error,
  label,
  onChange = () => {},
}) {

  return (
    <Fragment>
      <Label label={label} />
      <Rating
        initialRating={initialRating}
        emptySymbol={emptySymbol}
        fullSymbol={fullSymbol}
        fractions={fractions}
        readonly={readonly}
        onChange={onChange}
      />

      {error && <ErrorMessage text={error} />}
    </Fragment>
  )
}